import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=336cbe04&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=ts&"
export * from "./Tabs.vue?vue&type=script&lang=ts&"
import style0 from "./tabs.scss?vue&type=style&index=0&id=336cbe04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336cbe04",
  null
  
)

export default component.exports